import { FaArrowLeft } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import BirthdayEvents2026 from '../../../../../../Data/Events/2026/BirthdayEvents2026';
import "../../CSSBlogs/MainBlogsCSSFile.css";

const BirthdayCelebrations2026 = () => {
  return (
    <>
    <section className="blogs-heading-and-para-section-start-here">
        <div className="container-fluid">
            <div className="row justify-flex-start">
                <div className="col-md-12 blog-heading-and-para-div">
                    <h1>BIRTHDAYS #2026</h1>
                </div>
                {
                    BirthdayEvents2026.map((items) => {
                        return(
                            <div className="col-md-4 blog-yearly-birthday-celebration-div" key={items.id}>
                                <div className="blog-yearly-birthday-celebration-first-inner-div">
                                    <img src={items.birthdayImage} alt="Birthday Celebrations - Holistic Learning" className='img-fluid' />
                                    <h4>{items.birthdayName}</h4>
                                     <p>{items.birthdayDate}</p>
                                </div>
                            </div>
                        );
                    })
                }
                <div className="col-md-12 blog-button-div">
                    <NavLink to={"/events/more-events"} className="href"><button><span className='icon'><FaArrowLeft /></span> View All Events</button></NavLink>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default BirthdayCelebrations2026;